/**
 * District Mailing — custom cart drawer + Add to cart (catalog, homepage, PDP, brand grids)
 */
(function () {
  var ADD_BTN_SELECTOR =
    '.add-to-cart[data-variant-id], .dm-add-to-cart-btn[data-variant-id]';

  function formatMoney(amount) {
    return amount.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function getRoutes() {
    return window.routes || {};
  }

  function getVariantIdFromButton(btn) {
    if (!btn) return '';
    return String(btn.getAttribute('data-variant-id') || btn.dataset.variantId || '').trim();
  }

  function normalizeJsonText(text) {
    if (!text) return '';
    var trimmed = text.trim();

    if (trimmed.charCodeAt(0) === 0xfeff) {
      trimmed = trimmed.slice(1);
    }

    if (trimmed.startsWith('/*')) {
      trimmed = trimmed.replace(/^\/\*[\s\S]*?\*\//, '').trim();
    }

    return trimmed;
  }

  function isBlockedHtml(text) {
    if (!text || text.trim().charAt(0) !== '<') return false;
    return /verifying your connection|cf_chl|challenge-platform|storefront.password|password-page/i.test(text);
  }

  function buildCartErrorMessage(data, fallback) {
    if (!data) return fallback;
    return data.description || data.message || fallback;
  }

  function parseCartResponse(text, res) {
    if (!text || !text.trim()) {
      if (res && res.ok) return {};
      throw new Error('Empty response from cart service.');
    }

    var trimmed = normalizeJsonText(text);

    if (isBlockedHtml(trimmed)) {
      var blocked = new Error('blocked_request');
      blocked.code = 'BLOCKED_REQUEST';
      throw blocked;
    }

    if (trimmed.charAt(0) === '<') {
      throw new Error('Cart service returned an unexpected page. Refresh and try again.');
    }

    if (trimmed.charAt(0) !== '{' && trimmed.charAt(0) !== '[') {
      if (/expired|invalid.*token|unauthorized/i.test(trimmed)) {
        throw new Error('Theme preview session expired. Restart shopify theme dev, then refresh.');
      }
      throw new Error(trimmed.slice(0, 140));
    }

    try {
      return JSON.parse(trimmed);
    } catch (parseError) {
      throw new Error('Could not read cart response. Refresh and try again.');
    }
  }

  function isBlockedError(error) {
    return !!(error && (error.code === 'BLOCKED_REQUEST' || /blocked_request|connection check blocked/i.test(error.message || '')));
  }

  async function readFetchCartResponse(res) {
    var text = await res.text();
    var data = parseCartResponse(text, res);

    if (!res.ok || (data && data.status)) {
      throw new Error(buildCartErrorMessage(data, 'Could not add this item to your cart.'));
    }

    return data;
  }

  function buildDawnFormData(id) {
    var formData = new FormData();
    formData.append('id', id);
    formData.append('quantity', '1');
    formData.append('sections_url', window.location.pathname);
    return formData;
  }

  async function fetchCartJson() {
    var res = await fetch('/cart.js', {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    });

    if (!res.ok) {
      throw new Error('Could not load cart.');
    }

    return parseCartResponse(await res.text(), res);
  }

  async function postCartAdd(url, options) {
    var res = await fetch(url, {
      credentials: 'same-origin',
      redirect: 'follow',
      ...options
    });

    return readFetchCartResponse(res);
  }

  function ensureHiddenCartFrame() {
    var iframe = document.getElementById('dm-cart-add-frame');
    if (iframe) return iframe;

    iframe = document.createElement('iframe');
    iframe.id = 'dm-cart-add-frame';
    iframe.name = 'dm-cart-add-frame';
    iframe.title = 'Cart add';
    iframe.setAttribute('aria-hidden', 'true');
    iframe.tabIndex = -1;
    iframe.style.cssText =
      'position:fixed;width:0;height:0;border:0;opacity:0;pointer-events:none;left:-9999px;top:-9999px';
    document.body.appendChild(iframe);
    return iframe;
  }

  function wait(ms) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, ms);
    });
  }

  async function addVariantViaHiddenForm(variantId) {
    var id = String(variantId || '').trim();
    var routes = getRoutes();
    var cartAddUrl = routes.cart_add_url || '/cart/add';
    var iframe = ensureHiddenCartFrame();
    var previousCount = 0;

    try {
      var currentCart = await fetchCartJson();
      previousCount = currentCart.item_count || 0;
    } catch (error) {
      previousCount = 0;
    }

    await new Promise(function (resolve, reject) {
      var form = document.createElement('form');
      form.method = 'POST';
      form.action = cartAddUrl;
      form.target = iframe.name;
      form.style.display = 'none';
      form.setAttribute('accept-charset', 'UTF-8');

      var fields = {
        id: id,
        quantity: '1',
        return_to: window.location.pathname + window.location.search
      };

      Object.keys(fields).forEach(function (name) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = fields[name];
        form.appendChild(input);
      });

      var settled = false;

      function finish(err, cart) {
        if (settled) return;
        settled = true;
        if (form.parentNode) form.parentNode.removeChild(form);
        if (err) reject(err);
        else resolve(cart);
      }

      iframe.onload = function () {
        window.setTimeout(resolvePoll, 250);
      };

      async function resolvePoll() {
        for (var attempt = 0; attempt < 15; attempt += 1) {
          try {
            var cart = await fetchCartJson();
            var addedVariant = cart.items && cart.items.some(function (item) {
              return String(item.variant_id) === String(id);
            });

            if (cart.item_count > previousCount || addedVariant) {
              finish(null, cart);
              return;
            }
          } catch (error) {
            if (!isBlockedError(error) && attempt > 5) {
              finish(error);
              return;
            }
          }

          await wait(250);
        }

        finish(new Error('Could not confirm the item was added. Check your cart and try again.'));
      }

      document.body.appendChild(form);
      form.submit();
      window.setTimeout(resolvePoll, 400);
    });

    return fetchCartJson();
  }

  async function addVariantToCart(variantId) {
    var id = String(variantId || '').trim();
    if (!id) {
      throw new Error('This product is missing a variant. Open the product page to purchase.');
    }

    var numericId = Number(id);
    var payloadId = Number.isFinite(numericId) ? numericId : id;
    var routes = getRoutes();
    var cartAddUrl = routes.cart_add_url || '/cart/add';
    var sawBlocked = false;

    var strategies = [
      function () {
        return postCartAdd(cartAddUrl, {
          method: 'POST',
          headers: {
            Accept: 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: buildDawnFormData(id)
        });
      },
      function () {
        var params = new URLSearchParams();
        params.set('id', id);
        params.set('quantity', '1');

        return postCartAdd('/cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: params
        });
      },
      function () {
        return postCartAdd('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ items: [{ id: payloadId, quantity: 1 }] })
        });
      },
      function () {
        return postCartAdd('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ id: payloadId, quantity: 1 })
        });
      }
    ];

    var lastError = null;

    for (var i = 0; i < strategies.length; i += 1) {
      try {
        return await strategies[i]();
      } catch (error) {
        lastError = error;
        if (isBlockedError(error)) sawBlocked = true;
      }
    }

    if (sawBlocked || isBlockedError(lastError)) {
      try {
        return await addVariantViaHiddenForm(id);
      } catch (iframeError) {
        throw iframeError;
      }
    }

    throw lastError || new Error('Could not add this item to your cart.');
  }

  function ensureToastRoot() {
    var root = document.getElementById('dm-toast-root');
    if (root) return root;

    root = document.createElement('div');
    root.id = 'dm-toast-root';
    root.className = 'dm-toast-root';
    root.setAttribute('aria-live', 'polite');
    root.setAttribute('aria-atomic', 'true');
    document.body.appendChild(root);

    if (!document.getElementById('dm-toast-styles')) {
      var style = document.createElement('style');
      style.id = 'dm-toast-styles';
      style.textContent =
        '.dm-toast-root{position:fixed;top:24px;right:24px;z-index:100010;display:flex;flex-direction:column;gap:10px;pointer-events:none;max-width:min(420px,calc(100vw - 32px));}' +
        '.dm-toast{display:flex;align-items:flex-start;gap:12px;padding:14px 16px;border-radius:12px;background:#111;color:#fff;box-shadow:0 10px 30px rgba(0,0,0,.18);font-size:14px;line-height:1.45;opacity:0;transform:translateY(-8px);animation:dmToastIn .28s ease forwards;pointer-events:auto;}' +
        '.dm-toast--success{background:linear-gradient(135deg,#0f766e,#14b8a6);}' +
        '.dm-toast--error{background:linear-gradient(135deg,#991b1b,#dc2626);}' +
        '.dm-toast__text{flex:1;margin:0;}' +
        '.dm-toast__close{border:0;background:transparent;color:inherit;font-size:18px;line-height:1;cursor:pointer;padding:0;margin-left:4px;opacity:.85;}' +
        '@keyframes dmToastIn{to{opacity:1;transform:translateY(0);}}';
      document.head.appendChild(style);
    }

    return root;
  }

  function showToast(message, type) {
    if (!message) return;

    var root = ensureToastRoot();
    var toast = document.createElement('div');
    toast.className = 'dm-toast' + (type === 'success' ? ' dm-toast--success' : type === 'error' ? ' dm-toast--error' : '');

    var text = document.createElement('p');
    text.className = 'dm-toast__text';
    text.textContent = message;

    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'dm-toast__close';
    closeBtn.setAttribute('aria-label', 'Dismiss');
    closeBtn.innerHTML = '&times;';

    function removeToast() {
      if (toast.parentNode) toast.parentNode.removeChild(toast);
    }

    closeBtn.addEventListener('click', removeToast);
    toast.appendChild(text);
    toast.appendChild(closeBtn);
    root.appendChild(toast);

    window.setTimeout(removeToast, type === 'error' ? 6000 : 3500);
  }

  window.addVariantToCart = addVariantToCart;
  window.dmShowToast = showToast;

  function initDistrictCart() {
    var cartModal = document.getElementById('cart-modal');
    var cartItemsContainer = document.getElementById('cart-items');
    if (!cartModal || !cartItemsContainer) return false;

    cartItemsContainer.innerHTML = '';

    var cartBackdrop = document.getElementById('cart-backdrop');
    if (!cartBackdrop) {
      cartBackdrop = document.createElement('div');
      cartBackdrop.id = 'cart-backdrop';
      cartBackdrop.className = 'cart-backdrop';
      document.body.appendChild(cartBackdrop);
    }

    var closeCartBtn = document.getElementById('close-cart-modal');
    var headerCart = document.querySelector('#cart-icon-bubble');

    function animateProgressBar() {
      var bar = cartModal.querySelector('.cart-progress-bar');
      if (!bar) return;

      bar.style.transition = 'none';
      bar.style.width = '0%';
      bar.offsetHeight;
      bar.style.transition = 'width 1.2s cubic-bezier(0.4, 0, 0.2, 1)';
      requestAnimationFrame(function () {
        bar.style.width = '100%';
      });
    }

    function showCart() {
      cartBackdrop.style.display = 'block';
      cartModal.classList.add('active');
      document.body.classList.add('cart-open');
      animateProgressBar();
    }

    function hideCart() {
      cartBackdrop.style.display = 'none';
      cartModal.classList.remove('active');
      document.body.classList.remove('cart-open');
    }

    function updateHeaderCartCount(count) {
      if (!headerCart) return;

      var bubble = headerCart.querySelector('.cart-count-bubble');
      if (count > 0) {
        if (!bubble) {
          bubble = document.createElement('div');
          bubble.className = 'cart-count-bubble';
          bubble.innerHTML = '<span aria-hidden="true"></span>';
          headerCart.appendChild(bubble);
        }
        var span = bubble.querySelector('span[aria-hidden="true"]');
        if (span) span.textContent = count;
      } else if (bubble) {
        bubble.remove();
      }

      document.querySelectorAll('.cart-count').forEach(function (el) {
        el.textContent = count;
      });
    }

    function makeCartItemRow(item) {
      var unitPrice = item.price / 100;
      var linePrice = formatMoney(unitPrice * item.quantity);
      var imageSrc = item.image || item.featured_image || '';
      if (imageSrc && imageSrc.url) imageSrc = imageSrc.url;
      var um = item.title.match(/(\d+\s?(Count|Capsules|Ounce|oz|Tablets|Pack))/i);
      var variantLabel = um ? um[0] + ' (Pack of 1)' : '';

      return (
        '<div class="cart-item" data-key="' +
        item.key +
        '">' +
        '<a href="/products/' +
        item.handle +
        '">' +
        (imageSrc
          ? '<img src="' + imageSrc + '" class="cart-thumb" alt="' + item.title + '" />'
          : '') +
        '</a>' +
        '<div class="cart-info">' +
        '<a href="/products/' +
        item.handle +
        '" class="cart-title">' +
        item.title +
        '</a>' +
        '<p class="cart-variant">' +
        variantLabel +
        '</p>' +
        '<div class="cart-qty-row">' +
        '<button type="button" class="qty-minus" data-action="minus" data-key="' +
        item.key +
        '">−</button>' +
        '<span class="qty-count">' +
        item.quantity +
        '</span>' +
        '<button type="button" class="qty-plus" data-action="plus" data-key="' +
        item.key +
        '">+</button>' +
        '</div>' +
        '</div>' +
        '<button type="button" class="cart-remove" data-action="remove" data-key="' +
        item.key +
        '" aria-label="Remove">🗑️</button>' +
        '<div class="cart-price">$' +
        linePrice +
        '</div>' +
        '</div>'
      );
    }

    async function refreshCart() {
      try {
        var cart = await fetchCartJson();
        cartItemsContainer.innerHTML = cart.items.map(makeCartItemRow).join('');
        updateHeaderCartCount(cart.item_count);

        var summaryCountEl = document.getElementById('cart-summary-count');
        if (summaryCountEl) summaryCountEl.textContent = cart.item_count;

        var totalPriceEl = document.getElementById('cart-total-price');
        if (totalPriceEl) {
          totalPriceEl.textContent = '$' + formatMoney(cart.total_price / 100);
        }

        return cart;
      } catch (error) {
        return null;
      }
    }

    window.showCartPopup = showCart;
    window.refreshDistrictCart = refreshCart;

    if (headerCart) {
      headerCart.addEventListener('click', function (e) {
        e.preventDefault();
        showCart();
      });
    }

    document.querySelectorAll('.cart-icon').forEach(function (el) {
      if (el === headerCart) return;
      el.addEventListener('click', function (e) {
        e.preventDefault();
        showCart();
      });
    });

    if (closeCartBtn) closeCartBtn.addEventListener('click', hideCart);
    cartBackdrop.addEventListener('click', hideCart);

    cartItemsContainer.addEventListener('click', async function (e) {
      var btn = e.target.closest('button[data-action]');
      if (!btn) return;

      var key = btn.dataset.key;

      if (btn.dataset.action === 'remove') {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: key, quantity: 0 })
        });
        await refreshCart();
        document.dispatchEvent(new Event('cart:updated'));
        return;
      }

      var wrapper = cartItemsContainer.querySelector('.cart-item[data-key="' + key + '"]');
      if (!wrapper) return;

      var current = parseInt(wrapper.querySelector('.qty-count').textContent, 10);
      var delta = btn.dataset.action === 'plus' ? 1 : -1;
      var newQty = current + delta;
      if (newQty < 1) return;

      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: key, quantity: newQty })
      });
      await refreshCart();
      document.dispatchEvent(new Event('cart:updated'));
    });

    document.addEventListener('cart:open', showCart);

    refreshCart();
    return true;
  }

  function markButtonSoldOut(btn) {
    if (!btn) return;
    btn.disabled = true;
    btn.removeAttribute('data-variant-id');
    btn.classList.remove('is-loading', 'is-added');
    btn.textContent = 'Out of Stock';
  }

  async function handleAddToCartClick(e) {
    var addBtn = e.target.closest(ADD_BTN_SELECTOR);
    if (!addBtn || addBtn.disabled || addBtn.getAttribute('aria-disabled') === 'true') return;

    var variantId = getVariantIdFromButton(addBtn);
    if (!variantId) return;

    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') {
      e.stopImmediatePropagation();
    }

    if (addBtn.dataset.processing === 'true') return;

    var originalLabel = addBtn.textContent;
    addBtn.dataset.processing = 'true';
    addBtn.setAttribute('aria-disabled', 'true');
    addBtn.classList.add('is-loading');

    try {
      await addVariantToCart(variantId);

      addBtn.classList.remove('is-loading');
      addBtn.classList.add('is-added');

      if (typeof window.refreshDistrictCart === 'function') {
        await window.refreshDistrictCart();
      }

      if (typeof window.showCartPopup === 'function') {
        window.showCartPopup();
      } else if (getRoutes().cart_url) {
        window.location.href = getRoutes().cart_url;
        return;
      }

      document.dispatchEvent(new Event('cart:updated'));

      window.setTimeout(function () {
        addBtn.classList.remove('is-added');
      }, 500);
    } catch (error) {
      var message = error && error.message ? error.message : "Couldn't add to cart. Please try again.";

      if (message === 'blocked_request') {
        message = 'Could not add this item right now. Please refresh and try again.';
      }

      if (/sold out|unavailable|not available|already/i.test(message)) {
        markButtonSoldOut(addBtn);
      } else if (addBtn.textContent !== originalLabel) {
        addBtn.textContent = originalLabel;
      }

      showToast(message, 'error');
    } finally {
      addBtn.removeAttribute('aria-disabled');
      addBtn.classList.remove('is-loading');
      delete addBtn.dataset.processing;
    }
  }

  function init() {
    ensureHiddenCartFrame();
    document.addEventListener('click', handleAddToCartClick, true);
    initDistrictCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
